export default __webpack_public_path__ + "static/media/layout-1.0434dc50.jpg";